import * as React from 'react';
import { Button, Typography } from '@material-ui/core';
import {
    Link,
  } from "react-router-dom";
 
class NotFound extends React.Component<any> {
  public render() {
    const link: string = "/";
    const myLink = (props: any) => <Link to={link} {...props} />;
    return (
      <div>
        <Typography color="secondary" align="center" variant="body1">
          Tut uns leid, hier ist ein Fehler passiert. Diese Seite existiert
          leider nicht.
        </Typography>
        <Button
          color="primary"
          size="large"
          variant="contained"
          className="Buttons"
          component={myLink}
        >
          Get to the Homepage
        </Button>
      </div>
    );
  }
}
export default NotFound;


// WEBPACK FOOTER //
// ./src/components/notfound/NotFound.tsx